import React from "react";

import wp from "../tools/wp-endpoint.js";

import Spinner from "../tools/spinner.js";

export default class Ausbildung extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      pdfUrl1: undefined,
      pdfUrl2: undefined,
      pdfUrl3: undefined,
    };

    wp.posts()
      .slug("pdfs")
      .perPage(1)
      .embed()
      .then(
        function (data) {
          if (data && data.length == 1) {
            this.setState({
              pdfUrl1: data[0].acf["coaching-ubersicht_curricular"],
              pdfUrl2: data[0].acf["dvnlp"],
              pdfUrl3: data[0].acf["zahlen_daten_fakten_coach"],
            });
          }
        }.bind(this)
      );
  }

  render() {
    return (
      <div>
        <p>
          Menschen anleiten ihre vorhandenen Kompetenzen zu nutzen und anzuwenden – beruflich und privat - das ist das Ziel eines Coaches!
        </p>
        <p>
          Wenn wir über Coaching-Kompetenzen verfügen, steigert dies in hohem Maße unsere Fähigkeit Menschen zu führen und/oder im Kunden-,
          Klienten- und Patientengespräch wirksam zu beraten und zu motivieren. In der Wirtschaft, in kommunikativ ausgerichteten
          Tätigkeitsfeldern und in sozialen Berufen ist die Coaching-Kompetenz heute und in Zukunft daher gleichermaßen gefragt.
        </p>
        <p>
          Ob Du als professioneller Coach arbeiten willst oder eine Coaching-Ausbildung als Zusatz- Qualifikation anstrebst – Coaching
          eröffnet Dir neue berufliche Perspektiven und vermittelt wertvolle Impulse für Deine Persönlichkeitsentwicklung.
        </p>
        <p>
          Unsere Ausbildung vermittelt praxisorientierte Fähigkeiten, die Du gleich nach der ersten Kurseinheit anwenden kannst. Im Zuge der
          Ausbildung entwickelst Du Deine ganz persönliche Coaching-Kompetenz, die Deine bisherigen beruflichen Erfahrungen mit den
          Herangehensweisen und Methoden des Coachings kombiniert.
        </p>
        <p>
          Und nicht nur im Beruf kannst Du unmittelbar von einer Coaching-Ausbildung profitieren. Zahlreiche Teilnehmer bestätigen uns den
          hohen Nutzen der Ausbildung auch und gerade für ihre persönliche Entwicklung.
        </p>
        <p className="highlight">
          Wenn Du mehr über unsere Ausbildung wissen willst, als Du den folgenden Texten entnehmen kannst, freue ich mich auf Deinen Anruf
          oder Deine Email.
        </p>
        <p className="highlight">Viel Spaß beim Lesen</p>
        <p className="highlight">Heide Janowitz</p>
        <h2>Wer bei uns richtig ist</h2>
        <p className="nmtb">Menschen, die:</p>
        <ul>
          <li>sich persönlich weiterentwickeln möchten</li>
          <li>berufliche Veränderungen anstreben</li>
          <li>kommunikativ tätig sind und</li>
          <li>führen und entscheiden. </li>
        </ul>
        <h2>Teilnahmevoraussetzung</h2>
        <p>Neugier und Bereitschaft, sich weiter zu entwickeln</p>
        <h2>Was Du bei mir und bei uns lernst</h2>
        <p>
          Ich werde oft gefragt, wieso die Ergebnisse so schnell da sind und so gut funktionieren. Dazu gibt es viele mögliche Antworten.
          Eine davon ist: ich habe kreatives und gleichzeitig solides Handwerkszeug in über 30 Jahren Berufstätigkeit erprobt und die
          Schätze gesammelt. Hier biete ich nun die Möglichkeit, in die Berufspraxis, in das Tun des Berufes Coach hinein zu schnuppern, das
          eigenen Repertoire zu erweitern sowie sich persönlich weiter zu entwickeln.
        </p>
        <h2>Was Du bei uns lernst</h2>
        <p className="nmtb">Du lernst,</p>
        <ul>
          <li>
            zuzuhören und im Vertrauen auf Deine Intuition als Coach Einzelne und Gruppen oder Teams respektvoll und geduldig zu begleiten
          </li>
          <li>
            mit Hilfe gezielter Fragen und Aufgaben sowie der richtigen Mischung aus Humor und Ernst Menschen auf eigene Lösungsideen zu
            bringen.{" "}
          </li>
        </ul>
        <h2>Welche Inhalte Dich erwarten</h2>
        <ul>
          <li>Voraussetzungen und Rahmenbedingungen von Coachingprozessen (Angebotsprofil, Marketing, Kontrakt etc.)</li>
          <li>Methodische Kompetenz und Fachwissen im Coaching (Methoden, Fragetechniken, Feedbacktools etc.)</li>
          <li>Gestaltung der Coachingbeziehung (Atmosphäre, entwicklungsfördernde Aufgaben, Sprachgebrauch etc.)</li>
        </ul>
        <h2>Was zeichnet einen guten Coach aus</h2>
        <ul>
          <li>subjektive Sicht</li>
          <li>wache Sinne</li>
          <li>Sortierfähigkeit (wo bin ich jetzt, was ist da, was fehlt)</li>
          <li>Menschliche Stimmigkeit / Kongruenz (mit sich selber weitestgehend im Reinen sein)</li>
          <li>
            solide Arbeitsgrundlage, d.h. methodisches Handwerkszeug, kommunikatives Mundwerkzeug, perspektivische Gabe sowohl das Ego als
            auch das System zu erfassen
          </li>
          <li>Vertrauen in die eigene Intuition (Intuition = gesammeltes Wissen, im Unbewussten gespeichert)</li>
        </ul>
        <h2>Welche Methoden wir lehren</h2>
        <ul>
          <li>Neurolinguistisches Programmieren (NLP)</li>
          <li>Hypno-Coaching nach Milton Erickson</li>
          <li>Provokatives Vorgehen nach Frank Farrely</li>
          <li>HypnoPics &copy; von Heide Janowitz</li>
          <li>Lernen lernen auf Basis von Eva-Maria Schuhmacher</li>
          <li>Spielend lernen Improtechniken in Kombination mit Erlebnispädagogik</li>
        </ul>
        <h2>Welche Lehrformen wir einsetzen</h2>
        <ul>
          <li>
            Präsenztraining:
            <ul>
              <li>
                Demonstrationen, Gruppen- und Einzelarbeit, Diskussion, Hintergrundinformationen und Fragenklärung, Feedback zur praktischen
                Arbeit miteinander
              </li>
            </ul>
          </li>
          <li>
            Zwischen den Präsenztraining-Modulen:
            <ul>
              <li className="list-style-type-default">Peergruppen</li>
              <li className="list-style-type-default">Supervision per Email / Telefon</li>
              <li className="list-style-type-default">Eigenarbeit und Selbstcoaching</li>
            </ul>
          </li>
        </ul>
        <h2>Wovon Du profitierst</h2>
        <ul>
          <li>Praxistransfer von der ersten Minute an</li>
          <li>Schulung durch Selbsterfahrung</li>
          <li>kleine konstante Gruppe (max. Teilnehmerzahl 12)</li>
          <li>wir trainieren persönlich </li>
        </ul>
        <h2>Unsere Zutaten für Deine Weiterentwicklung</h2>
        <p>
          Wir bauen Dein Vorwissen mit ein und fordern und fördern Dich genau ab dem Niveau beruflicher Exzellenz, das Du zum Startbeginn
          hast
        </p>
        <p>Du lernst und vertiefst Dein Coaching Handwerkzeug in der Praxis</p>
        <p>Du erhältst berufliche und persönliche Begleitung in Deiner Entwicklung</p>
        <p>
          Wir sind Meisterinnen der Praxis, d.h. wir vermitteln Dir eine handfeste Fülle an Ansätzen und Vorgehensweisen, die wir aus
          unserem Berufsalltag erfahren, erprobt, häufig angewandt und für gut befunden haben
        </p>
        <p>
          Wir bringen Dir nicht nur das Nachkochen festgelegter Standardrezepte bei, sondern auch wie Du aus den Zutaten Dein eigenes
          Erfolgsrezept zusammenstellst und umsetzt
        </p>
        <p>Wir vermitteln Dir die folgenden Coaching Schritte anhand Deiner eigenen Fragestellung von Anfang an:</p>
        <p>
          Vertrauen aufbauen, Ziel klären, Hindernisse identifizieren und lösen, Schritte in die Veränderung tun und diese sinnvoll
          beibehalten
        </p>
        <h2>Zertifizierung</h2>
        <p>je nach Vorwissen: </p>
        <ul>
          <li>Zertifizierung zum Coach / Master Coach, DVNLP (siehe DVNLP-Curriculum samt Anerkennung)</li>
          <li>Zertifizierung zum Coach Silber / Gold / Platin</li>
        </ul>
        <h2>Ausbildungsplan</h2>
        <h3>Modul I</h3>
        <ul>
          <li>Selbstkonzept -/- Standortbestimmung -/- eigene Stärken und Schwächen</li>
          <li>über welche Ressourcen verfüge ich bereits</li>
          <li>welches Ziel verfolge ich</li>
          <li>welches sind meine ersten Schritte</li>
          <li>wie gehe ich mit Hindernissen um</li>
          <li>wie setze ich um und sichere anhaltend meine Ergebnisse</li>
        </ul>
        <h3>Modul II</h3>
        <ul>
          <li>Kommunikationswerkzeug und Außenwirkung</li>
          <li>was kann ich gut, was fehlt mir noch</li>
          <li>welche methodischen Arbeitsansätze taugen mir</li>
          <li>Vielfalt und praktisches Ausprobieren</li>
          <li>wo mache ich mir das Leben zu schwer und wie geht es einfacher</li>
        </ul>
        <h3>Supervision</h3>
        <ul>
          <li>was brauche ich, um meine Fähigkeiten praktisch einzusetzen</li>
          <li>welche Fragen haben sich in der Zwischenzeit ergeben beim selber coachen</li>
        </ul>
        <h3>Modul III</h3>
        <ul>
          <li>Feinschliff</li>
          <li>offene Wünsche beruflich / persönlich</li>
          <li>Vertiefung gewünschter Inhalte</li>
        </ul>
        <h3>Prüfungszeit</h3>
        <p>
          wer eine Zertifizierung möchte, wird praktisch geprüft. Wer zertifizierungsfrei bleiben möchte, darf das tun. Eine
          Teilnahmebestätigung wird ausgestellt ☺.
        </p>
        <p>
          Wer eine Zertifizierung, DVNLP* anstrebt, liefert vor der praktischen Prüfungszeit zusätzlich die Arbeiten gemäß dem Curriculum ab
          und erhält dazu Feedback.
        </p>
        <p>Wer eine Zertifizierung, cfc*, anstrebt, wird zu einem individuellen Entwicklungsthema praktisch überprüft.</p>
        <span className="gloss">*DVNLP = Deutscher Verband für Neuro-Linguistisches Programmieren</span>
        <span className="gloss">*cfc = Coaching for Competence</span>
        <h2>Methodenübergreifende Inhalte</h2>
        {this.state.pdfUrl1 ? (
          <p>
            <i className="far fa-file-pdf" aria-hidden="true"></i> <a href={this.state.pdfUrl1}>Coaching-Übersicht Curriculär</a>
          </p>
        ) : (
          <Spinner />
        )}
        <h2>DVNLP-Curriculum samt Anerkennung durch den DVNLP</h2>
        {this.state.pdfUrl2 ? (
          <p>
            <i className="far fa-file-pdf" aria-hidden="true"></i> <a href={this.state.pdfUrl2}>DVNLP</a>
          </p>
        ) : (
          <Spinner />
        )}
        <h2>Ausbildungsort, Zeit, Investition</h2>
        {this.state.pdfUrl3 ? (
          <p>
            <i className="far fa-file-pdf" aria-hidden="true"></i> <a href={this.state.pdfUrl3}>Zahlen, Daten, Fakten Coach</a>
          </p>
        ) : (
          <Spinner />
        )}
      </div>
    );
  }
}
